<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 7V10"
      stroke="#96C859"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 4V6"
      stroke="#96C859"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 4H9"
      stroke="#96C859"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 9H3"
      stroke="#96C859"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 7.09091H6.06667L7.13333 6H8.93707C9.03609 6.00005 9.13314 6.0283 9.21735 6.08157C9.30156 6.13485 9.36961 6.21105 9.41387 6.30164L10.1861 7.88018C10.2304 7.97077 10.2984 8.04697 10.3827 8.10024C10.4669 8.15352 10.5639 8.18176 10.6629 8.18182H11.4V7.09091H12.4667C12.6081 7.09091 12.7438 7.14838 12.8438 7.25067C12.9438 7.35296 13 7.4917 13 7.63636V10.9091C13 11.0538 12.9438 11.1925 12.8438 11.2948C12.7438 11.3971 12.6081 11.4545 12.4667 11.4545H11.4V10.3636H9.8V11.4545C9.8 11.5992 9.74381 11.7379 9.64379 11.8402C9.54377 11.9425 9.40812 12 9.26667 12H7.41867C7.33088 12 7.24446 11.9779 7.16705 11.9355C7.08964 11.8932 7.02365 11.832 6.97493 11.7573L6.06667 10.3636H5V7.09091V7.09091Z"
      stroke="#96C859"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

</template>